import React, { ReactNode } from 'react';
import { useMedia } from 'react-use';

const MAX_MOBILE_SCREEN_WIDTH_PX = 768;

export const useMobile = () => {
  return useMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH_PX}px)`);
};

export interface ResponsiveProps {
  mobile?: boolean;
  children?: ReactNode;
}

const Responsive = ({ children, mobile = true }: ResponsiveProps) => {
  const isMobile = useMobile();

  if (isMobile === mobile) {
    return <>{children}</>;
  }

  return null;
};

export default Responsive;
